class ChristmasGiveaway {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.formId = this.section.dataset.formId
    this.signup_btn = this.section.querySelector('.christmas-giveaway__signup-btn');
    this.calendarDays = this.section.querySelectorAll('.christmas-giveaway__calendar-day');
    this.popup = this.section.querySelector('#christmas-popup');
    this.popupContent = this.popup.querySelector('.popup-content');
    this.closePopup = this.popup.querySelector('.close-popup');
    this.noPrizeButton = this.popup.querySelector('.no-prize__button');

    // 弹窗各部分
    this.emailFormSection = this.popup.querySelector('.giveaway-email-form');
    this.discountCodeSection = this.popup.querySelector('.display-discount-code');
    this.copyButton = this.discountCodeSection.querySelector('.display-discount-code__copy-action');
    this.noPrizeSection = this.popup.querySelector('.no-prize');
    
    // 邮箱表单元素
    this.emailForm = this.emailFormSection.querySelector('.giveaway-email-form__form');
    this.emailInput = this.emailForm.querySelector('.giveaway-email-form__input');
    this.submitLoading = this.emailForm.querySelector('.loading__spinner');
    this.errorMsg = this.popup.querySelector('.custom-error');

    // 新增悬浮图标元素
    this.floatingIcon = this.section.querySelector('.christmas-floating-icon');

    // 存储折扣码信息
    this.hasPrize = 0;

    this.clickNumber = 0;

    // 动画配置
    this.config = {
      firstAnimation: true,
      minSpeed: 100,             // 初始速度(ms)
      maxSpeed: 400,            // 最终速度(ms)
    };

    this.originalScrollTo = window.scrollTo;
    
    this.initEvents();

     // 监听页面加载状态
    this.checkPageLoadStatus();
  }

  initEvents() {
    // 显示弹窗
    this.signup_btn.addEventListener('click', () => {
      this.showPopup('email');
    });

    // 关闭弹窗
    this.closePopup.addEventListener('click', () => {
      this.hidePopup();
    });

    this.noPrizeButton.addEventListener('click', () => {
      this.hidePopup();
    });

    // 表单提交
    this.emailForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        try {
            await this.validateEmail();
        } catch (error) {
            console.error('Email validation or submission failed:', error);
        }
    });

    // 复制按钮点击事件
    this.discountCodeSection.addEventListener('click', (e) => {
        if (e.target.closest('.display-discount-code__copy-action')) {
            this.copyDiscountCode();
        }
    });
  }

  /**
   * 初始化悬浮图标
   */
  initFloatingIcon() {
    if (!this.floatingIcon) return;
    
    this.floatingIcon.style.display = 'block';
    
    this.floatingIcon.addEventListener('click', (e) => {
      if (e.target.closest('.floating-icon-close')) {
          this.floatingIcon.style.display = 'none';
          return;
      }

      if (!this.signup_btn.disabled) {
        if(this.hasPrize == 0) {
          this.section.scrollIntoView({ behavior: 'smooth' });
        }
        this.signup_btn.click();
      }
    });
  }

  /**
   * 显示弹窗
   * @param {string} type - 'email' 或 'result'
   */
   showPopup(type) {
    // 先隐藏所有内容
    this.emailFormSection.style.display = 'none';
    this.discountCodeSection.style.display = 'none';
    this.noPrizeSection.style.display = 'none';
    
    if(this.hasPrize == 0 && type === 'email'){
      this.emailFormSection.style.display = 'flex';
    } else if (this.hasPrize == 1) {
      this.discountCodeSection.style.display = 'flex';
    } else if (this.hasPrize == 2) {
      this.noPrizeSection.style.display = 'flex';
    }
    
    // 显示弹窗
    this.popup.style.display = 'flex';

    // 🔴 禁止 scrollTo
    window.scrollTo = () => {
      console.log("scrollTo is disabled while popup is open");
      return false;
    };
  }

  /**
   * 隐藏弹窗
   */
  hidePopup() {
    this.popup.style.display = 'none';

    // 🔴 恢复 scrollTo
    window.scrollTo = this.originalScrollTo;
  }

  /**
   * 检查页面加载状态，完全加载后自动弹出
   */
  checkPageLoadStatus() {
    // 如果页面已经完全加载（DOMContentLoaded + 所有资源）
    if (document.readyState === 'complete') {
      this.triggerAutoPopup();
    } else {
      // 监听页面完全加载事件
      window.addEventListener('load', () => {
        this.triggerAutoPopup();
      });
    }
  }

  /**
   * 触发自动弹出（带延迟确保用户体验）
   */
  triggerAutoPopup() {
    // 初始化悬浮图标
    this.initFloatingIcon();
    this.signup_btn.removeAttribute('disabled');
    // 延迟1秒确保浏览器"加载圈圈"完全消失
    setTimeout(() => {
      // 检查是否已经有交互（避免干扰用户）
      if (this.clickNumber === 0) {
        this.showPopup('email');
      }
    }, 1000);
  }

  /**
   * 重置所有格子样式
   */
  resetCalendarDays() {
    this.calendarDays.forEach(day => {
      day.classList.remove('highlighted', 'selected');
    });
  }

  /**
   * 开始动态减速动画（根据API响应时间调整）
   */
  startDynamicDecelerationAnimation() {
    this.resetCalendarDays();
    clearInterval(this.animationInterval);
    
    let lastIndex = -1;
    let speed = this.config.minSpeed; // 初始速度
    let isSlowingDown = false;
    
    const animate = () => {
      // 移除之前的高亮
      this.calendarDays.forEach(day => day.classList.remove('highlighted'));
      
      // 获取新的随机索引(确保不重复)
      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * this.calendarDays.length);
      } while (randomIndex === lastIndex && this.calendarDays.length > 1);
      
      lastIndex = randomIndex;
      
      // 添加新的高亮
      this.calendarDays[randomIndex].classList.add('highlighted');
      
      // 如果开始减速，则逐渐降低速度
      if (isSlowingDown) {
        speed = Math.min(speed + 20, this.config.maxSpeed); // 每次增加20ms
      }
    };
    
    // 启动动画
    this.animationInterval = setInterval(animate, speed);
    
    // 返回一个可以触发减速的方法
    return {
      startSlowingDown: () => {
        isSlowingDown = true;
      },
      stop: () => {
        clearInterval(this.animationInterval);
        this.resetCalendarDays();
      }
    };
  }

  /**
   * 停止动画
   */
  stopAnimation() {
    clearInterval(this.animationInterval);
    this.resetCalendarDays();
  }

  /**
     * 验证邮箱格式并提交表单（Promise版本）
     * @returns {Promise<boolean>} 返回一个Promise，resolve表示验证和提交成功，reject表示失败
     */
    validateEmail() {
        return new Promise((resolve, reject) => {
            const email = this.emailInput.value.trim();
            const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            
            if (!isValid) {
                this.errorMsg.classList.add('active');
                this.emailInput.classList.add('error');
                reject(new Error('Invalid email format'));
                return;
            }
            
            this.errorMsg.classList.remove('active');
            this.emailInput.classList.remove('error');
            
            // 1. 获取目标表单元素
            const targetForm = document.querySelector(`[data-forms-id="forms-root-${this.formId}"] shopify-forms-embed`);
            const targetInput = targetForm?.shadowRoot?.querySelector('#email');
            const targetSubmitBtn = targetForm?.shadowRoot?.querySelector('[data-testid="btn-form-submit"]');
            
            if (!targetInput || !targetSubmitBtn) {
                console.error('Target form elements not found');
                // 检查页面是否已完全加载
                if (document.readyState === 'complete') {
                    // 页面已加载完毕，3秒后自动刷新
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
                reject(new Error('Target form elements not found'));
                return;
            }

            // 2. 填充值并触发提交
            if (targetInput) {
                targetInput.readOnly = false;
                targetInput.focus();
                const focusEvent = new Event('focus', { bubbles: true });
                targetInput.dispatchEvent(focusEvent);
                targetInput.value = email;
                const inputEvent = new Event('input', { bubbles: true });
                targetInput.dispatchEvent(inputEvent);
                const changeEvent = new Event('change', { bubbles: true });
                targetInput.dispatchEvent(changeEvent);
                targetInput.blur();
                const blurEvent = new Event('blur', { bubbles: true });
                targetInput.dispatchEvent(blurEvent);
                targetInput.readOnly = true;
            }

            // 3. 监听请求
            const cleanupMonitor = this.monitorRequestSuccess('/api/v2/form_submission', async (entry) => {
                try {
                  let animationControl = null;
                    // 表单提交成功后3秒关闭弹窗
                    setTimeout(() => {
                      this.hidePopup();
                      this.section.scrollIntoView({ behavior: 'smooth' });
                    }, 3000);

                    // 启动动画
                    animationControl = this.startDynamicDecelerationAnimation();

                    // 1. 获取当前URL并添加email参数
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set('email', this.emailInput.value.trim());
                    const checkUrl = currentUrl.toString();

                    // 2. 开始轮询检查优惠码
                    const result = await this.pollForDiscountCode(checkUrl);

                    // 3. 当开始获取到结果时，触发动画减速
                    animationControl.startSlowingDown();

                    // 4. 稍等片刻让减速效果可见
                    await new Promise(resolve => setTimeout(resolve, 800));
                    
                    // 5. 完全停止动画
                    animationControl.stop();
                    
                    // 6. 处理结果
                    this.handlePollingResult(result);
                    
                    resolve(true);
                } catch (error) {
                    console.error('优惠码检查失败:', error);
                    reject(error);
                } finally {
                    this.submitLoading.classList.add('hidden');
                    cleanupMonitor();
                }
            }, (error) => {
                console.error('表单提交失败:', error);
                this.submitLoading.classList.add('hidden');
                cleanupMonitor();
                reject(error);
            });
            
            // 4. 触发提交
            targetSubmitBtn.click();

            this.submitLoading.classList.remove('hidden');
        });
    }

    // 轮询检查优惠码
    async pollForDiscountCode(checkUrl, maxAttempts = 15, interval = 1000) {
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          console.log(`尝试第 ${attempt} 次检查优惠码...`);
          
          try {
              const response = await fetch(checkUrl);
              const html = await response.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const discountElement = doc.querySelector('.christmas-discount-result');
              
              if (discountElement) {
                  const couponCodeDes = discountElement.querySelector('.discount-coupon-discount-tier')?.textContent.trim();

                  return {
                      hasPrize: couponCodeDes == '' ? 2 : 1,
                      discountContent: doc.querySelector('.display-discount-code__content')
                  };
              }
              
          } catch (error) {
              console.error(`第 ${attempt} 次尝试出错:`, error);
              if (attempt === maxAttempts) {
                  throw new Error('轮询过程中出错且达到最大尝试次数');
              }
          }
          
          if (attempt < maxAttempts) {
              await new Promise(resolve => setTimeout(resolve, interval));
          }
      }
      
      location.reload(true);
      throw new Error('达到最大尝试次数仍未找到优惠码');
    }

    // 处理轮询结果
    handlePollingResult(result) {
        this.hasPrize = result.hasPrize;
        if (result.hasPrize) {
            // 更新折扣码显示内容
            if (result.discountContent) {
                const currentPageDiscountContent = this.section.querySelector('.display-discount-code__content');
                if (currentPageDiscountContent) {
                    currentPageDiscountContent.innerHTML = result.discountContent.innerHTML;
                }
            }
        } else {
            console.log('❌ 未中奖');
        }

        this.showPopup('result');
    }

    /**
     * 监听当前表单提交触发的请求（Promise版本）
     * @param {string} urlToMonitor - 要监听的URL（可以是完整URL或部分匹配）
     * @param {function} successCallback - 请求成功时的回调函数
     * @param {function} errorCallback - 请求失败时的回调函数
     */
    monitorRequestSuccess(urlToMonitor, successCallback, errorCallback) {
        // 1. 先记录当前已有的性能条目
        const existingEntries = performance.getEntriesByType('resource');
        
        // 2. 创建一个新的PerformanceObserver
        const observer = new PerformanceObserver((list) => {
            const newEntries = list.getEntries().filter(entry => 
                !existingEntries.some(existing => existing.name ===entry.name)
            );
            
            newEntries.forEach(entry => {
                if (entry.name.includes(urlToMonitor)) {
                    observer.disconnect(); // 找到匹配的请求后立即停止监听
                    
                    // Safari兼容性处理
                    if (typeof entry.responseStatus !== 'undefined') {
                        // 标准浏览器处理
                        if (entry.responseStatus >= 200 && entry.responseStatus < 300) {
                            successCallback(entry);
                        } else {
                            location.reload(true);
                            errorCallback(new Error(`Request failed with status ${entry.responseStatus}`));
                        }
                    } else {
                        // Safari浏览器处理 - 假设所有观察到的请求都是成功的
                        // 因为Safari不提供responseStatus，我们无法确定实际状态
                        successCallback(entry);
                    }
                }
            });
        });

        // 3. 开始监听
        observer.observe({ type: "resource", buffered: true });
        
        // 4. 设置超时
        const timeout = setTimeout(() => {
            observer.disconnect();
            errorCallback(new Error('Request monitoring timeout'));
        }, 20000);

        // 5. 返回一个清理函数（可选）
        return () => {
            clearTimeout(timeout);
            observer.disconnect();
        };
    }

  /**
     * 复制折扣码到剪贴板
     */
    copyDiscountCode() {
        const codeElement = this.discountCodeSection.querySelector('.display-discount-code__code-value');
        if (!codeElement) return;

        const discountCode = codeElement.textContent.trim();
        if (!discountCode) return;

        // 使用现代剪贴板API
        navigator.clipboard.writeText(discountCode).then(() => {
            // 复制成功反馈
            this.showCopyFeedback();
        }).catch(err => {
            console.error('Failed to copy text: ', err);
            // 降级方案
            this.fallbackCopyText(discountCode);
        });
    }

    /**
     * 显示复制成功的反馈
     */
    showCopyFeedback() {
        const copyButton = this.discountCodeSection.querySelector('.display-discount-code__copy-action');
        copyButton.classList.add('active');
        
        // 3秒后恢复原状
        setTimeout(() => {
            copyButton.classList.remove('active');
        }, 3000);
    }

    /**
     * 兼容旧浏览器的复制方法
     */
    fallbackCopyText(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // 防止滚动到页面底部
        document.body.appendChild(textarea);
        textarea.select();
        
        try {
            const successful = document.execCommand('copy');
            if (successful) {
            this.showCopyFeedback();
            }
        } catch (err) {
            console.error('Fallback copy failed: ', err);
        }
        
        document.body.removeChild(textarea);
    }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.christmas-giveaway-section').forEach(section => {
    new ChristmasGiveaway(section);
  });
});
